import whyChose from "../../assets/pictures/whyChose.png";
import "./WhyChoseUs.css"

function WhyChoseUs(){
    return(
        <>
       <div className="whychose_contain" id="about">
  {/* LEFT IMAGE */}
  <div className="whychose_left">
    <img src={whyChose}  alt="service"/>
  </div>

  {/* RIGHT CONTENT */}
  <div className="whychose_Right">
    <div className="whychose_line"></div>

    <h1 className="whychose_heading">
      Why Homeowners Trust <span>AinalSada</span>
    </h1>

    <div className="whychose_points">

      <div className="point">
        <h3>24/7 Emergency Services</h3>
        <p>
          Day or night, weekends or holidays—we’re always available when you need us most.
        </p>
      </div>

      <div className="point">
        <h3>Affordable Prices Across Town</h3>
        <p>
          We provide high-quality services at competitive rates, making home maintenance accessible for everyone.
        </p>
      </div>

      <div className="point">
        <h3>Fast Response, Quick Solutions</h3>
        <p>
          Our team acts quickly and efficiently to resolve your issues before they become major problems.
        </p>
      </div>

      <div className="point">
        <h3>Skilled & Certified Technicians</h3>
        <p>
          Experienced professionals ensure every job is completed with precision and long-lasting results.
        </p>
      </div>

      <div className="point">
        <h3>All-in-One Home Services</h3>
        <p>
          From AC repair to plumbing and electrical work, we handle everything under one roof.
        </p>
      </div>

      <div className="point">
        <h3>Customer Satisfaction First</h3>
        <p>
          We prioritize your comfort with reliable service, clear communication, and guaranteed satisfaction.
        </p>
      </div>

    </div>
  </div>
</div>
        </>
    )
}

export default WhyChoseUs;